<template>
  <modal
    :disabled="false"
    :modal-heading="modalHeading"
    :modal-open="showModal"
    :toggle-modal="toggleModal"
  >
    <div>
      <div v-html="modalText" />
      <a class="btn btn-cta" href="#" @click.prevent="startEditing">{{
        texts.startEditing
      }}</a>
    </div>
  </modal>
</template>

<script>
import Modal from 'Components/Modal.vue';
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'CreatorModal',

  components: {
    Modal,
  },

  data() {
    return {
      obituaryId: this.$mountEl.dataset.obituaryId,
      isPublished: !!this.$mountEl.dataset.isPublished,
      modalText: this.$mountEl.dataset.modalText,
      modalHeading: this.$mountEl.dataset.modalHeading,
      texts: lavendlaObituary.creator,
    };
  },

  computed: {
    ...mapState('creator', ['showModal', 'isLoggedIn']),
  },

  mounted() {
    this.checkShouldShowModal({
      id: this.obituaryId,
      isPublished: this.isPublished,
    });
  },

  methods: {
    ...mapActions('creator', ['checkShouldShowModal']),
    ...mapMutations('creator', ['setState']),
    startEditing() {
      this.toggleModal();
    },
    toggleModal() {
      this.setState({ showModal: !this.showModal });
      this.setState({ isEditMode: true });
    },
  },
};
</script>
